import { Box, Button, TextField, IconButton, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCharge from "../../modal/modalCharge";
import imageCompression from "browser-image-compression";
import { PostPatrimonio } from "../../services/amoxarifado.services";
import ModalSector from "../../modal/amoxarifado/modalSector";
import ModalPatrimonio from "../../modal/amoxarifado/modalPatrimonio";
import { useDropzone } from "react-dropzone";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { es } from 'date-fns/locale';


const Patrimonios = () => {
    const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const [registrationError, setRegistrationError] = useState(false);
    const [error, setError] = useState("");
    const [modalSector, setModalSector] = useState(false);
    const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
    const [modalPatrimonio, setModalPatrimonio] = useState(false);
    const [droppedItems, setDroppedItems] = useState([]);
    const [dropError, setDropError] = useState('');
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");

    const handleFormSubmit = async (values, { resetForm }) => {
        if (droppedItems.length === 0) {
            setDropError("Debe subir al menos una imagen");
            setIsLoading(false);
            return;
        }
        setIsLoading(true);

        const uploadedPaths = await uploadDroppedImages(droppedItems);

        const valuesToSend = {
            patrimonio: values.nombre.toUpperCase(),
            id_subsector: values.id_subsector, // este viene del modal
            antiguedad: values.antiguedad
            ? values.antiguedad.toISOString().split("T")[0]
            : null,
            marca: values.marca.toUpperCase(),
            modelo: values.modelo.toUpperCase(),
            costo: values.costo,
            obs: values.obs,
            imagen: uploadedPaths.join(';')
        };



        try {
            await PostPatrimonio(valuesToSend);
            console.log("🚀 ~ handleFormSubmit ~ valuesToSend:", valuesToSend)
        
            setRegistrationSuccess(true);
            resetForm();
            setDroppedItems([]); 
            resetForm();
        } catch (error) {
            console.error("error sending data", error);
            setRegistrationError(true);
            setError(error.message);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 3000);
        }
    };

    const handleDrop = (acceptedFiles) => {
        const newItems = acceptedFiles.map((file) => ({
            name: file.name,
            preview: URL.createObjectURL(file),
            file,
        }));
        setDroppedItems((prevItems) => [...prevItems, ...newItems]);
        setDropError('');
    };

    const handleRemoveItem = (index) => {
        setDroppedItems((prevItems) => prevItems.filter((_, i) => i !== index));
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: 'image/*',
        onDrop: handleDrop,
    });

    const uploadDroppedImages = async (items) => {
        const uploadedImagePaths = [];
        
        for (const item of items) {
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            };
        
            try {
                const compressedFile = await imageCompression(item.file, options);
                const formData = new FormData();
                formData.append("image", compressedFile);
                
                const response = await fetch(`${getApiImagen()}/upload`, {
                    method: "POST",
                    body: formData,
                });
                if (response.ok) {
                    const data = await response.json();
                    uploadedImagePaths.push(data.filePath);
                } else {
                    console.error("Error al subir la imagen", item.name);
                }
            } catch (error) {
                console.error("Error al comprimir/subir la imagen:", error);
            }
        }
        return uploadedImagePaths;
    };


    return (
        <Box m="20px">
            <Header title="Registro Patrimonios" subtitle="Registrar Patrimonio" />

            {isLoading && <LoadingSpinner />}

            {registrationSuccess && (
                <ModalSucces
                    open={registrationSuccess}
                    onClose={() => setRegistrationSuccess(false)}
                />
            )}

            {registrationError && (
                <ModalError
                    open={registrationError}
                    onClose={() => setRegistrationError(false)}
                    error={error}
                />
            )}

            <Formik
                onSubmit={handleFormSubmit}
                initialValues={{
                    nombre: "",
                    id_subsector: "",
                    antiguedad: null,
                    modelo: "",
                    costo: "",
                    marca: "",
                    obs: "",
                    imagen: "",
                    sector: "",
                }}
                validationSchema={checkoutSchema}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched
                }) => (
                    <>
                        <form onSubmit={handleSubmit}>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                                }}
                            >
                                {/* Nombre */}
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Nombre"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.nombre}
                                    name="nombre"
                                    error={!!touched.nombre && !!errors.nombre}
                                    helperText={touched.nombre && errors.nombre}
                                    sx={{ gridColumn: "span 2" }}
                                />
                                {/* Sector */}
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    label="Sector"
                                    name="sector"
                                    value={values.sector || ""}
                                    onClick={() => setModalSector(true)}
                                    onBlur={handleBlur}
                                    error={!!touched.sector && !!errors.sector}
                                    helperText={touched.sector && errors.sector}
                                    sx={{ gridColumn: "span 1" }}
                                    InputProps={{
                                      readOnly: true, // evita que el usuario escriba y se mezcle
                                    }}
                                />  
                                {/* Antigüedad */}
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
  <DatePicker
    label="Fecha"
    value={values.antiguedad}
    onChange={(newValue) => {
      setFieldValue("antiguedad", newValue);
    }}
    onError={() => {
      setFieldTouched("antiguedad", true);
    }}
    slotProps={{
      textField: {
        fullWidth: true,
        variant: "filled",
        error: Boolean(touched.antiguedad && errors.antiguedad),
        helperText: touched.antiguedad && errors.antiguedad,
        onBlur: () => setFieldTouched("antiguedad", true),
        sx: { gridColumn: "span 1" },
      },
    }}
  />
</LocalizationProvider>
                                {/* Marca */}
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Marca"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.marca}
                                    name="marca"
                                    error={!!touched.marca && !!errors.marca}
                                    helperText={touched.marca && errors.marca}
                                    sx={{ gridColumn: "span 2" }}
                                />
                                {/* Modelo */}
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Modelo"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.modelo}
                                    name="modelo"
                                    error={!!touched.modelo && !!errors.modelo}
                                    helperText={touched.modelo && errors.modelo}
                                    sx={{ gridColumn: "span 2" }}
                                />
                                {/* Observaciones */}
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="text"
                                    label="Observacion"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.obs}
                                    name="obs"
                                    error={!!touched.obs && !!errors.obs}
                                    helperText={touched.obs && errors.obs}
                                    sx={{ gridColumn: "span 2" }}
                                />
                                 {/* Costo */}
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    type="number"
                                    label="Costo"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.costo}
                                    name="costo"
                                    error={!!touched.costo && !!errors.costo}
                                    helperText={touched.costo && errors.costo}
                                    sx={{ gridColumn: "span 2" }}
                                />
                                {/* Imagen */}
                                {values.imagen && (
                                    <Box sx={{ gridColumn: "span 4" }}>
                                        <img
                                            src={values.imagen}
                                            alt="Vista previa"
                                            style={{ width: "100%", height: "auto", marginTop: "10px" }}
                                        />
                                    </Box>
                                )}
                            </Box>
                            <Box mt={4}>
                                <Typography variant="h6">
                                    Arrastra y suelta las imágenes aquí:
                                </Typography>
                                <Box
                                    {...getRootProps()}
                                    sx={{
                                        border: "2px dashed #cccccc",
                                        padding: "20px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        backgroundColor: isDragActive
                                            ? "rgb(206, 220, 0)"
                                            : "transparent",
                                        height: isDragActive ? "200px" : "100px",
                                        transition: "height 0.3s ease-in-out",
                                    }}
                                >
                                    <input {...getInputProps()} />
                                    <Typography>
                                        {isDragActive
                                            ? "Suelte aquí su archivo"
                                            : "Arrastra y suelta las fotos aquí, o haz clic para seleccionar archivos"}
                                    </Typography>
                                </Box>
                                        
                                {dropError && <Typography color="error">{dropError}</Typography>}
                                        
                                <Box
                                    mt={2}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        border: "1px solid #cccccc",
                                        borderRadius: "5px",
                                    }}
                                >
                                    {droppedItems.map((item, index) => (
                                        <Box key={index} mt={2} sx={{ padding: "1vh" }}>
                                            <Typography>• {item.name}</Typography>
                                            <IconButton onClick={() => handleRemoveItem(index)} size="small">
                                                <CloseIcon />
                                            </IconButton>
                                            <img src={item.preview} alt={item.name} width="100px" />
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                            <Box display="flex" justifyContent="end" mt="20px">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "rgb(206, 220, 0)",
                                        color: "black",
                                        height: "7vh",
                                        width: "10vw",
                                        borderRadius: "20px",
                                        "&:hover": { backgroundColor: "#bac609" },
                                    }}
                                >
                                    Registrar
                                </Button>
                            </Box>
                            </form>
                            <ModalSector
                                open={modalSector}
                                onClose={() => setModalSector(false)}
                                onSelectSector={(sector) => {
                                    setSectorSeleccionado(sector);
                                    setModalSector(false);
                                    setModalPatrimonio(true);
                                }}
                            />
                            <ModalPatrimonio
                                open={modalPatrimonio}
                                onClose={() => setModalPatrimonio(false)}
                                onSelectPatrimonio={(patrimonio) => {
                                    setFieldValue("id_subsector", patrimonio.id);
                                    setFieldValue("sector", patrimonio.descripcion);
                                    setFieldTouched("sector", true);
                                    setModalPatrimonio(false);
                                }}
                                sector={sectorSeleccionado}
                            />
                            <ModalCharge isLoading={isLoading} />
                    </>
                )}          
            </Formik>
        </Box>
    );
};

const checkoutSchema = yup.object().shape({
    nombre: yup.string().required("El nombre es requerido"),
    sector: yup.string().required("El sector es requerido"),
    antiguedad: yup
  .date()
  .nullable()
  .required("La fecha es requerida"),
    modelo: yup.string().required("El modelo es requerido"),
    costo: yup.number().typeError("Debe ser un número").required("El costo es requerido"),
    marca: yup.string().required("La marca es requerida"),
    obs: yup.string().optional(),
    imagen: yup.string().optional()
});

export default Patrimonios;